<template>
  <ClasificationForm />
</template>
  
<script>
  import ClasificationForm from '@/components/match-clasification/ClasificationForm.vue';
  export default {
    name: "ClasificationCreatePage",
    components: {
      ClasificationForm,
    },
  };
</script>
  